import { Outlet } from "react-router-dom";

export default function EventRouter() {
  return <Outlet />;
}
